<template>
    <div>
        <!--<nav-back :dataTit="'模板'"></nav-back>-->
        <!--<def-hn></def-hn>-->
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore">
            <div class="frame-ul cont-width">
                <div class="frame-one" v-for="(item, index) in list" :key="index" @click="checkFrame(item)">
                    <img :src="item.src"/>
                </div>
            </div>
        </mt-loadmore>
    </div>
</template>

<script>
  import { Toast } from 'mint-ui'
  import NavBack from "../public/navBack"
  import DefHn from "../public/defHn"
  import config from '../../common/config.js'
  let wx = require('weixin-js-sdk')
  export default {
    name: "frame",
    components: {
      NavBack, DefHn},
    data () {
      return {
        list: [],
        pages: 1,
        allLoaded: false
      }
    },
    mounted () {
      // WeixinJSBridge.call('hideOptionMenu')
      this.getAll()
      this.goyanzheng()
    },
    methods: {
      checkFrame (i) {
        this.$router.push('/photo/index?eid=' + this.$route.query.eid + '&fid=' + i.src)
      },
      getAll () {
        let that = this
        this.$g.ajax({
          method: 'post',
          path: 'frames/getList',
          data: {
            event_id: this.$route.query.eid,
            page: this.pages
          },
          cbSuccess(data) {
            that.$refs.loadmore.onTopLoaded()
            that.$refs.loadmore.onBottomLoaded();
            that.list = data.memo.list
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1000
            })
          }
        })
      },
      loadTop () {
        this.pages = 1
        this.getAll()
      },
      loadBottom () {
        this.pages++
        this.getAll()
      },
      goyanzheng () {
        let that = this
        this.$g.ajax({
          path: 'uploaders/jssdksign',
          method: 'post',
          data: {
            url: location.href.split('#')[0]
          },
          cbSuccess (data) {
            that.begin(data.memo.nonceStr, data.memo.signature, data.memo.timestamp)
          },
          cbError (error) {
            let msg = error.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1500
            })
          }
        })
      },
      begin (nonceStr, signature, timestamp) {
        let that = this
        let activityView = JSON.parse(sessionStorage.getItem('activityView'))
        let shareWxLink = config.host + '?id=' + activityView.id
        wx.config({
          debug: false,
          appId: 'wx97dae6033b09528a',
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage']
        })
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: activityView.title, // 分享标题
            desc: activityView.share_text !== null ? activityView.share_text : activityView.title, // 分享描述
            link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
            success: function () {
              // that.$emit('shareok')
              // 设置成功
              //   alert('分享给朋友,分享到QQ,设置成功')
            }
          })
          wx.updateTimelineShareData({
            title: activityView.title, // 分享标题
            link: shareWxLink,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
            success: function () {
              // 设置成功
              // alert('分享到朋友圈,分享到QQ空间,设置成功')
            }
          })
        })
        wx.onMenuShareTimeline({
          title: activityView.title, // 分享标题
          link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
          }
        })
        wx.onMenuShareAppMessage({
          title: activityView.title, // 分享标题
          desc: activityView.share_text !== null ? activityView.share_text : activityView.title, // 分享描述
          link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' ,
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户点击了分享后执行的回调函数
          }
        })
        wx.error(function (res) {
          console.log(res)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.frame-ul{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 10px;
    overflow-y: auto;
    .frame-one{
        width: 45%;
        border: 1px solid #ccc;
        text-align: center;
        line-height: 50%;
        padding: 10px 0;
        margin-bottom: 20px;
        img{
            width: 50%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/album/frame.vue